import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseRepository} from "./base/base.repository";

@Injectable({
    providedIn: 'root'
})
export class AttachmentRepository extends BaseRepository{
    constructor(public httpClient: HttpClient) {
        super(httpClient);
        this.path = 'dashboard/admin/attachments';
    }

    saveFileAndAttachment(file:File, attachment){
        const formData: FormData = new FormData();
        formData.append('file', file, file.name);
        formData.append('attachment', JSON.stringify(attachment));
        return super.postFile(this.path, formData);
    }

    updateFileForAttachment(file: File, attachmentId:number) {
        const path = this.path +'/'+attachmentId;
        const formData: FormData = new FormData();
        formData.append('file', file, file.name);
        return super.patchFile(path, formData);
    }
    clearCacheForAttachment( attachmentId:number) {
        const path = this.path +'/clear-cache/'+attachmentId;
        return super.patch(path);
    }
    getAllDeletable() {
        const path = this.path+'/deletable';
        return super.get(path);
    }
}
